
import { types, actions } from './requests'
export const GETVARIANTLIST_TYPES = {
    ...types('GETVARIANTLIST'),
}
export const GETVARIANTLIST_ACTIONS = {
    ...actions('GETVARIANTLIST'),
}